import canvasing from "../assets/images/canvasing.jpeg";
import chat from "../assets/images/chat.jpeg";
import chat2 from "../assets/images/chat2.jpeg";
import leaderboard from "../assets/images/leaderboard.jpeg";
import competition from "../assets/images/competition.jpeg";
import customfields from "../assets/images/customfields.png";
import AISales from "../assets/images/AISales.png";
import Calendar from "../assets/images/Calendar.png";
import '../assets/styles/Project.scss';

function Project() {
  return (
    <div className="projects-container" id="projects">
      <h1>Achievements</h1>
      <div className="projects-grid">
        <div className="project">
          <a href="https://www.repcard.com/features/canvassing" target="_blank" rel="noreferrer"><img src={canvasing} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/features/canvassing" target="_blank" rel="noreferrer"><h2>Canvassing</h2></a>
          <p>Boost field sales productivity with RepCard’s Canvassing tool—plan routes, track in real time, and access rich lead data to optimize time and outreach.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com/features/chat" target="_blank" rel="noreferrer"><img src={chat} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/features/chat" target="_blank" rel="noreferrer"><h2>Chat</h2></a>
          <p>RepCard’s Chat feature enables instant, secure, and organized team communication with group chats, voice, and media sharing—all in one place.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com/features/business-card" target="_blank" rel="noreferrer"><img src={chat2} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/features/business-card" target="_blank" rel="noreferrer"><h2>Digital Business Profile</h2></a>
          <p>RepCard makes it easy to collect and share positive customer reviews with customizable designs, QR codes, and links—helping you build trust, showcase credibility, and win more deals with smart, automated notifications.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com/features/leaderboards" target="_blank" rel="noreferrer"><img src={leaderboard} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/features/leaderboards" target="_blank" rel="noreferrer"><h2>Leaderboard</h2></a>
          <p>RepCard’s Leaderboards showcase real-time sales achievements, highlight top performers, and inspire healthy competition—motivating your team to strive for personal bests and continuous improvement.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com/features/competitions" target="_blank" rel="noreferrer"><img src={competition} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/features/competitions" target="_blank" rel="noreferrer"><h2>Competition</h2></a>
          <p>RepCard’s Competition feature enables teams to engage in friendly contests, track progress, and celebrate achievements—fostering a culture of collaboration and motivation.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com/#team-calendar" target="_blank" rel="noreferrer"><img src={Calendar} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com/#team-calendar" target="_blank" rel="noreferrer"><h2>Calendar</h2></a>
          <p>RepCard’s Calendar feature streamlines appointment management by integrating scheduling, syncing with external calendars, and sending automated reminders—helping teams stay organized, save time, and focus on closing more deals.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com" target="_blank" rel="noreferrer"><img src={customfields} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com" target="_blank" rel="noreferrer"><h2>Custom Fields</h2></a>
          <p>RepCard’s Custom Fields feature allows teams to tailor their data collection processes, ensuring they capture the most relevant information for their unique needs.</p>
        </div>
        <div className="project">
          <a href="https://www.repcard.com" target="_blank" rel="noreferrer"><img src={AISales} className="zoom" alt="thumbnail" width="100%" /></a>
          <a href="https://www.repcard.com" target="_blank" rel="noreferrer"><h2>AI Sales(In Progress)</h2></a>
          <p>RepCard’s AI Sales feature leverages artificial intelligence to enhance sales strategies, providing insights and recommendations tailored to individual team members.</p>
        </div>
      </div>
    </div>
  );
}

export default Project;